import * as Yup from 'yup';

export const nuevoPuestoValidation = (puestos) => (
  Yup.object().shape({
    nombre: Yup.string().max(150, 'Máximo 150 caracteres').required('Campo Obligatorio').test({
      name: "puestoNoExiste",
      message: "El puesto ya está registrado. Por favor, ingrese un nombre diferente.",
      test: function (value) {
        if (!puestos.some((e) => e.nombre === value)) {
          return true;
        }
        return false;
      }
    }),
    ciuo: Yup.string().required('Campo Obligatorio').nullable(),
  })
)